var _g, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 92,
    viewBox: "0 0 75 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1057_10675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8629 9.11035H6.61712C3.35957 9.11035 0.718811 11.7511 0.718811 15.0087V82.1019C0.718811 85.3594 3.35957 88.0002 6.61712 88.0002H64.8629C68.1204 88.0002 70.7612 85.3594 70.7612 82.1019V15.0087C70.7612 11.7511 68.1204 9.11035 64.8629 9.11035Z",
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61712 10.1104H64.8629C67.5681 10.1104 69.7612 12.3034 69.7612 15.0087V82.1019C69.7612 84.8071 67.5681 87.0002 64.8629 87.0002H6.61712C3.91186 87.0002 1.71881 84.8071 1.71881 82.1019V15.0087C1.71881 12.3034 3.91186 10.1104 6.61712 10.1104Z",
    fill: "#D0D0D0",
    stroke: "#2C2828",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82899 81.3647H62.6658C63.0568 81.3647 63.4319 81.2094 63.7085 80.9328C63.985 80.6563 64.1403 80.2812 64.1403 79.8902V17.2207C64.1403 16.8296 63.985 16.4545 63.7085 16.178C63.4319 15.9014 63.0568 15.7461 62.6658 15.7461H8.82899C8.43791 15.7461 8.06285 15.9014 7.78631 16.178C7.50977 16.4545 7.35442 16.8296 7.35442 17.2207V79.8902C7.35442 80.2812 7.50977 80.6563 7.78631 80.9328C8.06285 81.2094 8.43791 81.3647 8.82899 81.3647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6658 80.6147H8.82899C8.63683 80.6147 8.45252 80.5384 8.31664 80.4025C8.18076 80.2666 8.10442 80.0823 8.10442 79.8902V17.2207C8.10442 17.0285 8.18076 16.8442 8.31664 16.7083C8.45252 16.5724 8.63682 16.4961 8.82899 16.4961H62.6658C62.8579 16.4961 63.0422 16.5724 63.1781 16.7083C63.314 16.8442 63.3903 17.0285 63.3903 17.2207V79.8902C63.3903 80.0823 63.314 80.2666 63.1781 80.4025C63.0422 80.5384 62.8579 80.6147 62.6658 80.6147Z",
    fill: "#F8F8F8",
    stroke: "#2C2828",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5298 46.7115C39.759 46.7115 42.0217 44.7946 42.0217 41.5751V41.5259C42.0217 38.6751 40.3522 37.3725 37.101 36.4878C34.1353 35.7013 33.4324 35.1115 33.4324 33.7844V33.7352C33.4324 32.6047 34.355 31.6954 35.9367 31.6954C37.1449 31.6954 38.2872 32.1378 39.4735 32.998C39.6931 33.1454 39.9128 33.2191 40.1764 33.2191C40.8794 33.2191 41.4505 32.6047 41.4505 31.8183C41.4505 31.2285 41.165 30.8107 40.8574 30.6141C39.4735 29.5819 37.9138 29.0166 35.9806 29.0166C32.9271 29.0166 30.7304 31.0564 30.7304 34.0056V34.0547C30.7304 37.2251 32.5756 38.3064 35.8488 39.1912C38.7046 39.9285 39.3197 40.592 39.3197 41.8208V41.87C39.3197 43.148 38.2652 44.0327 36.5957 44.0327C34.9262 44.0327 33.5642 43.3937 32.2901 42.2632C32.1143 42.1158 31.8727 41.9929 31.4992 41.9929C30.7963 41.9929 30.2251 42.6073 30.2251 43.3937C30.2251 43.8852 30.4448 44.303 30.7523 44.5488C32.4658 45.9742 34.4429 46.7115 36.5298 46.7115Z",
    fill: "#2C2828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1234 29.0166L36.1234 48.1861",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1057_10675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.193 8.66779C42.203 8.50822 42.203 8.34813 42.193 8.18856C42.193 6.28203 41.4691 4.45359 40.1805 3.10548C38.892 1.75736 37.1443 1 35.322 1C33.4997 1 31.752 1.75736 30.4635 3.10548C29.1749 4.45359 28.451 6.28203 28.451 8.18856C28.4414 8.34815 28.4414 8.50821 28.451 8.66779H20.2608C19.7748 8.66779 19.3088 8.86976 18.9652 9.22925C18.6215 9.58875 18.4285 10.0763 18.4285 10.5847V18.2525C18.4285 18.7609 18.6215 19.2485 18.9652 19.608C19.3088 19.9675 19.7748 20.1695 20.2608 20.1695H50.5115C50.9974 20.1695 51.4635 19.9675 51.8071 19.608C52.1507 19.2485 52.3437 18.7609 52.3437 18.2525V10.5847C52.3437 10.0763 52.1507 9.58875 51.8071 9.22925C51.4635 8.86976 50.9974 8.66779 50.5115 8.66779H42.193Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.193 8.66779C42.203 8.50822 42.203 8.34813 42.193 8.18856C42.193 6.28203 41.4691 4.45359 40.1805 3.10548C38.892 1.75736 37.1443 1 35.322 1C33.4997 1 31.752 1.75736 30.4635 3.10548C29.1749 4.45359 28.451 6.28203 28.451 8.18856C28.4414 8.34815 28.4414 8.50821 28.451 8.66779H20.2608C19.7748 8.66779 19.3088 8.86976 18.9652 9.22925C18.6215 9.58875 18.4285 10.0763 18.4285 10.5847V18.2525C18.4285 18.7609 18.6215 19.2485 18.9652 19.608C19.3088 19.9675 19.7748 20.1695 20.2608 20.1695H50.5115C50.9974 20.1695 51.4635 19.9675 51.8071 19.608C52.1507 19.2485 52.3437 18.7609 52.3437 18.2525V10.5847C52.3437 10.0763 52.1507 9.58875 51.8071 9.22925C51.4635 8.86976 50.9974 8.66779 50.5115 8.66779H42.193Z",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.4285 54.085H30.2251",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4285 61.457H30.2251",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4285 68.8301H30.2251",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0217 54.085H53.8183",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0217 61.457H53.8183",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0217 68.8301H53.8183",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3861,
    cy: 7.63566,
    r: 2.93644,
    fill: "#D0D0D0",
    stroke: "#2C2828",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1057_10675",
    x: 0.718811,
    y: 0.25,
    width: 74.0424,
    height: 91.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1057_10675"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1057_10675",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1057_10675",
    x: 17.6785,
    y: 0.25,
    width: 37.4152,
    height: 22.6699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1057_10675"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1057_10675",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxReport);
export default __webpack_public_path__ + "static/media/tax-report.d6667df84c235f8c5cba2a2a432ef524.svg";
export { ForwardRef as ReactComponent };